import Navbar from "../components/navbar"
import { useEffect, useState } from "react"
import { FaBars } from "react-icons/fa"
import ProgressBar from "../components/progress-bar"
import { Switch } from "antd"
import Footer from "../components/footer"
import { Link } from "react-router-dom"
import { AiOutlineInfo } from "react-icons/ai"
import { MdKeyboardArrowRight } from "react-icons/md"


const CheckListsPage = () => {
    const [navShown, setNavShown] = useState("hidden")
    const [showBar, setShowBar] = useState(true)
    const [showXmark, setShowXmark] = useState("hidden")
    const [openDrawer, setOpenDrawer] = useState(false)
    const [IsShowCheckLists, setIsShowCheckLists] = useState(true)
    const [checklists, setChecklists] = useState([])

    const openNav = () => {
        setNavShown("block")
        setShowBar("hidden")
        setShowXmark("inline")
    }
    const closeNav = () => {
        setNavShown("hidden")
        setShowBar("inline")
        setShowXmark("hidden")
    }

    const DrawerFooter = () => {
        return (
            <div className="flex justify-center items-center py-2">
                <div className="flex flex-col gap-y-1 w-fit">
                    <button className="bg-cyan-400 py-2 rounded-full px-20" onClick={() => setOpenDrawer(false)}>DONE</button>
                    <button className="underline text-cyan-600" onClick={() => setOpenDrawer(false)}>CANCEL</button>
                </div>
            </div>
        )
    }

    const checkListData = [
        {
            title: "critical Care/ICU",
            recommended: true,
            notStarted: true,
            inMyList: true
        },
        {
            title: "critical Care/ICU",
            recommended: true,
            notStarted: true,
            inMyList: true
        },
        {
            title: "critical Care/ICU",
            recommended: true,
            notStarted: true,
            inMyList: true
        },
        {
            title: "critical Care/ICU",
            recommended: true,
            notStarted: true,
            inMyList: true
        },
        {
            title: "critical Care/ICU",
            recommended: true,
            notStarted: true,
            inMyList: true
        },
        {
            title: "for just checking",
            recommended: true,
            notStarted: true,
            inMyList: false
        },
        {
            title: "critical Care/ICU",
            recommended: true,
            notStarted: true,
            inMyList: true
        },
        {
            title: "critical Care/ICU",
            recommended: true,
            notStarted: true,
            inMyList: true
        },
    ]

    useEffect(() => {
        if (IsShowCheckLists) {
            let data = checkListData.filter((item) => item.inMyList === true)
            setChecklists(data)
            console.log("if", data)
        } else if (!IsShowCheckLists) {
            let data = checkListData.filter((item) => item.inMyList !== true)
            setChecklists(data)
            console.log("else", data)
        }
    }, [IsShowCheckLists])


    return (
        <Navbar active={"profile"} navShow={navShown}>
            <div className="flex w-full bg-cyan-900 items-center fixed z-20">
                <FaBars className={`text-[20px] text-white relative left-4 lg:hidden ${showBar}`} onClick={openNav} />
                <span className={`text-[25px] ${showXmark} text-white font-bold relative left-72`} onClick={closeNav}>
                    X
                </span>
                <h1 className="text-center text-white py-4 w-full font-bold">References</h1>
            </div>
            <div className="relative top-14 pb-56">
                <div className="p-3 lg:px-8">
                    <div>
                        <h1 className="font-semibold mb-2">Application progress</h1>
                        <ProgressBar active={"checklists"} />
                    </div>
                    <div className="mt-7 text-sm">
                        <p>
                            Navigate to checklists for the clinical skills you're most experienced in and want to travel for. Along with your work history, this help us match you to jobs that fit your skills and experience - so be sure to fill out accurately and completely!
                        </p>
                        <p className="mt-3">
                            Help us understand your skills.
                        </p>
                    </div>

                    <hr className="mt-4" />

                    <div className="w-fit gap-x-2 mt-4 text-sm">
                        <label className="flex justify-between gap-x-1 items-center">
                            Only show my checklists
                            <Switch className="bg-gray-400" onChange={(e) => setIsShowCheckLists(e)} checked={IsShowCheckLists}></Switch>
                        </label>
                    </div>

                    <div className="flex flex-col gap-y-4 mt-4">
                        {
                            checklists?.map((val, index) => {
                                return (
                                    <div className="rounded-lg p-3" style={{ boxShadow: "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px" }}>
                                        <div className="flex justify-between items-center">
                                            <h1 className="capitalize text-sm font-semibold">{val?.title}</h1>
                                            <MdKeyboardArrowRight />
                                        </div>
                                        <div className="flex gap-x-2 mt-2">
                                            {val?.recommended && <button className="bg-blue-200 p-1 rounded text-xs">
                                                Recommended
                                            </button>}
                                            {val?.notStarted && <button className="rounded flex gap-x-2 bg-red-200 p-1 items-center text-xs">
                                                <span className="border-2 rounded-full border-red-500 h-4 w-4">

                                                </span>
                                                <span>
                                                    Not started
                                                </span>
                                            </button>}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>

                </div>
                <div className="fixed bottom-0 w-full">
                    <div className="bg-white p-3 border-t-2">
                        <div className="flex items-center gap-x-1">
                            <span className="h-5 w-5 rounded-full border border-blue-500 flex justify-center items-center">
                                <AiOutlineInfo className="text-blue-500" />
                            </span>
                            <span className="text-blue-500">Complete all recommended checklists to continue</span>
                        </div>
                        <div className="flex gap-x-4 mt-2">
                            <button disabled={true} className="uppercase border border-cyan-400 py-1 px-6 rounded-full disabled:cursor-not-allowed disabled:bg-gray-400 disabled:border-0 disabled:text-gray-200 text-sm text-center">
                                save & continue
                            </button>
                            <Link to={"/education"} className="uppercase border border-cyan-400 py-1 px-6 rounded-full text-sm text-center">
                                skip to next section
                            </Link>
                        </div>
                    </div>
                    <Footer></Footer>
                </div>
            </div>
        </Navbar>
    )
}

export default CheckListsPage